import { createStore } from 'vuex';
import getters from './getters';
import app from './modules/app';
import settings from './modules/settings';
import user from './modules/user';
import tagsView from './modules/TagsView';
import permission from './modules/permission';
import info from './modules/info';
import config from './modules/config';

const store = createStore({
  modules: {
    app,
    settings,
    user,
    tagsView,
    info,
    permission,
    config
  },
  getters
});

export default store;
